import React, { useState } from 'react';
import cn from 'classnames';
import { ThumbsUp, ThumbsDown } from 'react-feather';
import IconButton from 'ui/IconButton';
import { seismicTheme, Theme, MicroToast } from '@seismic/mantle';

const Feedback = ({ sendFeedback }) => {
  const [feedbackSent, setFeedbackSent] = useState(false);
  const [selected, setSelected] = useState(null);
  const [error, setError] = useState(false);

  const handleClick = async e => {
    const score = e.currentTarget.value;
    setSelected(score);

    const resp = await sendFeedback(score);
    setFeedbackSent(resp.feedbackSent);
    setError(resp.error);
  };

  const microToastContent = error
    ? t('lessons.editor.element_assistant.feedback.error')
    : t('lessons.editor.element_assistant.feedback.sent');
  const microToastVariant = error ? 'error' : 'success';

  return (
    <Theme theme={seismicTheme({ useGlobal: true })} className="Feedback">
      <div className="feedback-microtoast-container" />
      <MicroToast
        showing={feedbackSent}
        containerSelector=".feedback-microtoast-container"
        duration={3000}
        placement="top-start"
        content={microToastContent}
        variant={microToastVariant}
      >
        <div
          className={cn('d-f', { 'feedback-sent': feedbackSent })}
          aria-label={t('lessons.editor.element_assistant.feedback.label')}
        >
          <span>{t('lessons.editor.element_assistant.feedback.label')}</span>
          <IconButton
            aria-label={t(
              'lessons.editor.element_assistant.feedback.thumbs_up',
            )}
            className={cn('pr-0', {
              'feedback-selected': selected === '1',
            })}
            value="1"
            onClick={handleClick}
          >
            <ThumbsUp size={16} />
          </IconButton>
          <IconButton
            aria-label={t(
              'lessons.editor.element_assistant.feedback.thumbs_down',
            )}
            value="0"
            className={cn({
              'feedback-selected': selected === '0',
            })}
            onClick={handleClick}
          >
            <ThumbsDown size={16} />
          </IconButton>
        </div>
      </MicroToast>
    </Theme>
  );
};

export default Feedback;
